module.exports = __webpack_public_path__ + "l.no2.ef4ff5af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/l.no2.jpg
// module id = 9kIC
// module chunks = 0